module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitle",
    attrs: {
      "id": "pub"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Publisher’s note")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The publishers would like to thank Jasmine Scott Neale, Alfie McNamara, Jiri Keller, and Liz Steel for their kind consent to appear in this book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428c3523","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Publishers.vue
// module id = 72
// module chunks = 0